module.exports = __webpack_public_path__ + "img/simple-breath.bc56474f.jpg";